import { createUseTranslation } from "core/session/translation";

export const useBackgroundSelectorTranslation = createUseTranslation({
  en: {
    bgColorLabel: "Background Color",
    borderColorLabel: "Border Color",
  },
});
